import { Link } from "react-router-dom";
import "../Styles/NotFound.css";

export default function NotFound() {
    return (
        <div className="notfound">
            <div className="notfound__content">
                <svg
                    className="notfound__basket"
                    viewBox="0 0 200 160"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                >
                    <path
                        d="M40 60 L160 60 L148 140 Q146 150 136 150 L64 150 Q54 150 52 140 Z"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="4"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M70 60 Q70 25 100 25 Q130 25 130 60"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="4"
                        strokeLinecap="round"
                    />
                    <line x1="60" y1="80" x2="68" y2="135" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
                    <line x1="100" y1="80" x2="100" y2="135" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
                    <line x1="140" y1="80" x2="132" y2="135" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
                    <circle cx="100" cy="95" r="3" fill="currentColor" className="notfound__dot" />
                </svg>

                <p className="notfound__eyebrow">Page introuvable</p>
                <h1 className="notfound__title">Page not found</h1>
                <p className="notfound__text">
                    La page que vous cherchez n'existe pas ou a été déplacée.
                    Vérifiez l'adresse ou retournez faire vos courses.
                </p>

                <Link to="/" className="notfound__cta">
                    Retour à l'accueil
                </Link>
            </div>
        </div>
    );
}